import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import { PaymentMethods } from './addTournament';
import { TournamentRankType } from './getTournamentDetails';

export default (build: EndpointBuilder<any, any, any>) =>
  build.query<packagesListResponse, packagesListBody>({
    query: (body) => ({
      url: `v4/pitch-owner/tournaments?status=${body.status}&limit=${body.limit}&page=${body.page}&search=${body.search}`,
      method: 'Get',
      signal: body.signal,
    }),
  });

export interface packagesListBody {
  status: TournamentsStatus;
  limit: number;
  page: number;
  search?: string;
  signal?: AbortSignal;
}

export enum TournamentsStatus {
  ACTIVE = 'active',
  DEACTIVATED = 'deactivated',
}

export interface packagesListResponse {
  data: Tournament[];
  meta: {
    current_page: number;
    from: number;
    path: string;
    per_page: number;
    to: number;
    total?: number;
  };
}

export enum TournamentProgress {
  NotStarted = 'not_started',
  Started = 'started',
  Ended = 'ended',
}

export interface TournamentPlayer {
  user_id: number;
  image_url: string;
}

export interface Tournament {
  id: number;
  name: string;
  name_ar: string;
  start_date: string;
  end_date: string;
  venue: string;
  geolat: string;
  geolng: string;
  teams_per_group: string | number;
  teams_to_qualify_per_group: number;
  is_live: 0 | 1;
  is_global: 0 | 1;
  is_private: 0 | 1;
  price_per_team: string;
  currency: string;
  currency_ar: string;
  registration_deadline: string;
  gender: string;
  prizes: string;
  additional_info: string | null;
  daily_timings: string | null;
  players_count_per_team: number | null;
  map_url: string | null;
  set_end_score: number | null;
  country: {
    id: number;
    name: string;
    name_ar: string;
    code: string;
    visible: number;
    phone_code: string;
    iso_code: string;
    notes: string | null;
  };
  sport_type: {
    id: number;
    name_en: string;
    name_ar: string;
  };
  tournament_type: {
    id: number;
    name: string;
    name_ar: string;
  };
  supported_payment_methods: [
    {
      id: PaymentMethods;
      tag: string;
      title: string;
    },
  ];
  sum_categories_max_number_of_teams: number;
  sum_categories_registered_teams_count: number;
  registered_teams_meta_info: TournamentPlayer[];
  categories: {
    id: number;
    name: string;
    name_ar: string;
    max_number_of_teams: number | null;
    registered_teams_count: number | null;
    show_schedule: boolean;
  }[];
  tournament_image?: File | string;
  rank_type_id?: number;
  rank_id?: number;
  interface_type?: InterfaceType;
  is_waiting_list?: 0 | 1;
  is_golden_point?: 0 | 1;
  is_third_set_tie_breaker?: 0 | 1;
  show_teams?: 0 | 1;
  rank?: {
    id: number;
    name: string;
    name_ar: string;
  };
  rank_type: {
    id: TournamentRankType;
    name: string;
    name_ar: string;
  };
  config: {
    show_teams: 0 | 1;
    schedule_notifications: 0 | 1;
    age_restriction: 0 | 1;
  };
}

export enum InterfaceType {
  NORMAL = '1',
  LEAGUE = '2',
}

export enum CategoriesGender {
  female = 'female',
  male = 'male',
  mixed = 'mixed',
}
